export type MicrophoneAccess = "granted" | "prompt" | "denied" | "unknown";

export async function microphoneAccess(): Promise<MicrophoneAccess> {
  if (!navigator.permissions?.query) return "unknown";
  try {
    const status = await navigator.permissions.query({
      name: "microphone" as PermissionName,
    });
    return status.state as MicrophoneAccess;
  } catch {
    return "unknown";
  }
}

export function watchMicrophoneAccess(
  onChange: (access: MicrophoneAccess) => void,
): () => void {
  let status: PermissionStatus | null = null;
  let cancelled = false;
  const handler = () => {
    if (status) onChange(status.state as MicrophoneAccess);
  };
  if (navigator.permissions?.query) {
    navigator.permissions
      .query({ name: "microphone" as PermissionName })
      .then((result) => {
        if (cancelled) return;
        status = result;
        result.addEventListener("change", handler);
        onChange(result.state as MicrophoneAccess);
      })
      // Permissions API — not network (query-exceptions).
      .catch(() => onChange("unknown"));
  } else {
    onChange("unknown");
  }
  return () => {
    cancelled = true;
    status?.removeEventListener("change", handler);
  };
}
